import { Component, OnInit } from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "./../../../environments/environment";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-language-list",
  templateUrl: "./language-list.component.html",
  styleUrls: ["./language-list.component.css"],
})
export class LanguageListComponent implements OnInit {
  constructor(
    private pagesService: BaseService,
    private route: ActivatedRoute
  ) {}
  contentData: any = [];
  apiParam = { slug: "", limit: 20, offset: 0, subslug: "" };
  shimarStatus = true;
  app_constant: any;
  loadMore: boolean;
  languageData: any = {};
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.app_constant = environment;
    this.route.params.subscribe((params) => {
      if (params["slug"]) {
        this.apiParam.slug = params["slug"];
        this.apiParam.subslug = params["subslug"];
      }
      this.getData();
    });
  }
  getData() {
    this.pagesService
      .getDataByLanguageSluge(this.apiParam)
      .subscribe((data: any) => {
        this.languageData = data.results;
        this.contentData = this.contentData.concat(data.results.content);
        this.shimarStatus = false;
        this.loadMore = false;
      });
  }
  onScroll() {
    this.loadMore = true;
    const offset = this.apiParam.offset + this.apiParam.limit;
    if (this.languageData.content_count > offset) {
      this.apiParam.offset += this.apiParam.offset + this.apiParam.limit;
      this.getData();
    } else {
      this.loadMore = false;
    }
  }
}
